





































































































import Vue from 'vue'
import moment from 'moment/moment'
import config from '@/utils/config'
import request from '@/utils/request'
import skyconText from '@/utils/skyconText'
import CimissDataService from '@/service/CimissDataService'
import warningImg from '@/utils/warningImg'
import windElement from '@/utils/windElement'
import townList from "@/assets/json/townList.json";
import { Icon, Toast } from 'vant';
export default Vue.extend({
  components: {
    Icon
  },
  props: ['address', 'longitude', 'latitude'],
  computed: {
    lngLat(): any {
      const { longitude, latitude } = this
      return { longitude, latitude }
    },
  },
  watch: {
    // lngLat() {
    //   this.getData()
    // },
  },
  data() {
    return {
      data: {},
      warnInfos: [],
      adminCode: config.defaultStationObj.adminCode,
      stationId: config.defaultStationObj.station_id_c,
      stationName: '大荔',
      stationList: [],
      isOptionsVisible: false,
      selectedStation: {
        station_id_c: '',
        station_name: '',
        town_name: '',
      },
      stationData: {
        windDirection: '',
        lon: 0,
        lat: 0,
        win_d_avg_2mi: undefined
      },
      countryStationData: {},
    }
  },
  created() {
    // this.getData()
    this.getStationList()
    this.getStationData()
    //获取国家站小时数据
    this.getStationHourData()
  },
  methods: {
    toggleOptions: function () {
      this.isOptionsVisible = !this.isOptionsVisible;
    },
    selectOption: function (option: any) {
      this.selectedStation = option;
      this.stationId = this.selectedStation.station_id_c
      this.stationName = this.selectedStation.station_name
      this.isOptionsVisible = false;
      this.getStationData()
    },

    getStationData() {
      //清空站点信息
      this.stationData = {
        windDirection: '',
        lon: 0,
        lat: 0,
        win_d_avg_2mi: undefined
      }
      //获取分钟数据
      const elements = 'station_name,lon,lat,station_id_c,pre,tem,win_s_avg_2mi,win_d_avg_2mi,rhu,lat,lon,datetime,prs'
      CimissDataService.stationData(this.stationId, '', '', '', elements, 'surf_min_data').then((res: any) => {
        if (res && res.length > 0) {
          this.stationData = res[0]
          this.stationData.windDirection = windElement.windDirection(this.stationData.win_d_avg_2mi)
          // this.getData(this.stationData.lon, this.stationData.lat)
          this.emitHistory(this.stationId, this.stationName)
        } else {
          //获取小时数据
          const hourElements = 'station_name,lon,lat,station_id_c,pre_1h,tem,win_s_avg_2mi,win_d_avg_2mi,rhu,lat,lon,datetime,prs'
          CimissDataService.stationData(this.stationId, '', '', '', hourElements).then((res: any) => {
            if (res && res.length > 0) {
              this.stationData = res[0]
              this.stationData.windDirection = windElement.windDirection(this.stationData.win_d_avg_2mi)
              // this.getData(this.stationData.lon, this.stationData.lat)
              this.emitHistory(this.stationId, this.stationName)
            }
          })
        }
      })
    },
    getStationHourData() {
      // const elements = 'station_name,lon,lat,station_id_c,pre_1h,tem,win_s_avg_2mi,win_d_avg_2mi,win_s_inst_max,win_d_inst_max,rhu,lat,lon,datetime,prs'
      const elements = 'station_name,lon,lat,station_id_c,pre_1h,tem,win_s_avg_2mi,win_d_avg_2mi,rhu,lat,lon,datetime,prs,vis'
      CimissDataService.stationData(this.stationId, '', '', '', elements).then((res: any) => {
        if (res && res.length > 0) {
          this.countryStationData = res[0]
        }
      })
    },

    emitHistory(stationId: string, stationName: string) {
      const statioInfo = {
        stationId,
        stationName
      }
      this.$emit('getHistoryData', statioInfo)
    },
    getStationList() {
      CimissDataService.stationList(this.adminCode).then((res: any) => {
        this.stationList = res
      })
    },
    showTips(type: string, message: string) {
      if (type === 'pre') {
        Toast('雨量：整点过去一小时降雨量');
      } else if (type === 'wind') {
        Toast('风向:' + message + '度')
      } else if (type === 'vis') {
        Toast('能见度数据来源为大荔国家站')
      }
    }
  },
  filters: {
    dtFormat(datetime: number) {
      const time = moment(datetime, 'YYYYMMDDHHmmss')
      return time.add(8, 'hours').format('YYYY年M月D日HH时mm分')
    }
  }
})
